import React, { LabelHTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Label.module.scss';

const Label = ({ className, children, ...restProps }: LabelHTMLAttributes<HTMLLabelElement>) => (
  <label {...restProps} className={classNames(styles.label, className)}>
    {children}
  </label>
);

export default Label;
